import { DashBoardComponent } from './admin/dashboard/dashboard.component';
import { ErrorComponent } from './error/error.component';
import { AuthGuard } from './auth/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationComponent } from './registration/registration.component';
import { LoginComponent } from './login/login.component';
import { RoleComponent } from './admin/auth/role/role.component';
import { RolePermissionComponent } from './admin/auth/role-permission/role-permission.component';
import { UserRoleComponent } from './admin/auth/user-role/user-role.component';
import { UserComponent } from './admin/auth/user/user.component';
import { UserEditComponent } from './admin/auth/user/edit/user-edit.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { EduCategoryComponent } from './admin/context/edu/edu-category/edu-category.component';
import { EduCategoryEditComponent } from './admin/context/edu/edu-category/edit/edu-category-edit.component';
import { EduProjectComponent } from './admin/context/edu/edu-project/edu-project.component';
import { EduProjectEditComponent } from './admin/context/edu/edu-project/edit/edu-project-edit.component';
import { PayAccountVNPComponent } from './admin/context/pay/pay-account-vnp/pay-account-vnp.component';
import { ForgotPassComponent } from './forgot-pass/forgot-pass.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { PayTransactionVNPRechargeComponent } from './admin/context/pay/pay-transaction-vnp-recharge/pay-transaction-vnp-recharge.component';
import { PayTransactionVNPRetailComponent } from './admin/context/pay/pay-transaction-vnp-retail/pay-transaction-vnp-retail.component';
import { EduBannerComponent } from './admin/context/edu/edu-banner/edu-banner.component';
import { EduBannerEditComponent } from './admin/context/edu/edu-banner/edit/edu-banner-edit.component';
import { EduBlogComponent } from './admin/context/edu/edu-blog/edu-blog.component';
import { EduBlogEditComponent } from './admin/context/edu/edu-blog/edit/edu-blog-edit.component';
import { PayWithdrawalRequestComponent } from './admin/context/pay/pay-withdrawal-request/pay-withdrawal-request.component';
import { PayWithdrawalRequestEditComponent } from './admin/context/pay/pay-withdrawal-request/edit/pay-withdrawal-request-edit.component';
import { EduProjectErrorComponent } from './admin/context/edu/edu-project-error/edu-project-error.component';
import { EduProjectErrorEditComponent } from './admin/context/edu/edu-project-error/edit/edu-project-error-edit.component';
import { EduProjectViolationComponent } from './admin/context/edu/edu-project-violation/edu-project-violation.component';
import { EduProjectViolationEditComponent } from './admin/context/edu/edu-project-violation/edit/edu-project-violation-edit.component';
import { EduProjectCommentComponent } from './admin/context/edu/edu-project-comment/edu-project-comment.component';
import { EduProjectCommentEditComponent } from './admin/context/edu/edu-project-comment/edit/edu-project-comment-edit.component';

const routes: Routes = [
    // default
    { path: '', redirectTo: 'techbyte/admin/login', pathMatch: 'full' },

    // anonymous
    { path: 'techbyte/admin/error', component: ErrorComponent },
    { path: 'techbyte/admin/login', component: LoginComponent },
    { path: 'techbyte/admin/resetpass', component: ResetPassComponent },
    { path: 'techbyte/admin/forgotpass', component: ForgotPassComponent },
    { path: 'techbyte/admin/registration', component: RegistrationComponent },

    // admin
    {
        path: 'techbyte/admin',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                component: DashBoardComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.DashBoard.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'role',
                component: RoleComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.AspNetRole.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'role-permission',
                component: RolePermissionComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.AspNetRolePermission.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'user-role',
                component: UserRoleComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.AspNetUserRole.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'user',
                component: UserComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.AspNetUser.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'user/edit',
                component: UserEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.AspNetUser.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'user/edit/:id',
                component: UserEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.AspNetUser.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-category',
                component: EduCategoryComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduCategory.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-category/edit',
                component: EduCategoryEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduCategory.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-category/edit/:guid',
                component: EduCategoryEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduCategory.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project',
                component: EduProjectComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProject.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project/edit',
                component: EduProjectEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProject.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project/edit/:guid',
                component: EduProjectEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProject.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'pay-account-vnp',
                component: PayAccountVNPComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.PayAccountVNP.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'pay-transaction-vnp-recharge',
                component: PayTransactionVNPRechargeComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.PayTransactionVNPRecharge.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'pay-transaction-vnp-retail',
                component: PayTransactionVNPRetailComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.PayTransactionVNPRetail.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-banner',
                component: EduBannerComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduBanner.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-banner/edit',
                component: EduBannerEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduBanner.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-banner/edit/:guid',
                component: EduBannerEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduBanner.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-blog',
                component: EduBlogComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduBlog.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-blog/edit',
                component: EduBlogEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduBlog.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-blog/edit/:guid',
                component: EduBlogEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduBlog.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'pay-withdrawal-request',
                component: PayWithdrawalRequestComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.PayWithdrawalRequest.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'pay-withdrawal-request/edit/:guid',
                component: PayWithdrawalRequestEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.PayWithdrawalRequest.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project-error',
                component: EduProjectErrorComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProjectError.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project-error/edit/:guid',
                component: EduProjectErrorEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProjectError.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project-violation',
                component: EduProjectViolationComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProjectViolation.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project-violation/edit/:guid',
                component: EduProjectViolationEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProjectViolation.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project-comment',
                component: EduProjectCommentComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProjectComment.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
            {
                path: 'edu-project-comment/edit/:guid',
                component: EduProjectCommentEditComponent,
                canActivate: [NgxPermissionsGuard],
                data: {
                    permissions: {
                        only: ['Permissions.EduProjectComment.Read'],
                        redirectTo: '/techbyte/admin/error'
                    }
                }
            },
        ]
    },
    // { path: 'techbyte/admin/dashboard', component: DashBoardComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },
    // { path: 'techbyte/admin/role', component: RoleComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },
    // { path: 'techbyte/admin/role-permission', component: RolePermissionComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },
    // { path: 'techbyte/admin/user-role', component: UserRoleComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },
    // { path: 'techbyte/admin/user', component: UserComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },
    // { path: 'techbyte/admin/user/edit', component: UserEditComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },
    // { path: 'techbyte/admin/user/edit/:id', component: UserEditComponent, canActivate: [AuthGuard], data: { permittedRoles: ['techbyte/admin'] } },

    // out-route
    { path: '**', component: ErrorComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }